var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 16",
    style: {
      enableBackground: "new 0 0 20 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0A1227;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1042 -407 )"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1051.3,419h0.6l1.3-1.3l-1.7-1.7l-1.3,1.3v0.6h1.1V419z M1056.9,411.2c0.1-0.1,0.1-0.3,0-0.4 c-0.1-0.1-0.2-0.1-0.4,0l-3.9,4c-0.1,0.1-0.1,0.3,0,0.4c0.1,0.1,0.2,0.1,0.4,0L1056.9,411.2z M1057.6,417.2 c0.1,0.1,0.2,0.2,0.2,0.3v2.2c0,0.9-0.3,1.7-0.9,2.3c-0.6,0.6-1.4,1-2.3,1h-9.3c-0.9,0-1.6-0.3-2.3-1c-0.6-0.6-0.9-1.4-0.9-2.3 v-9.5c0-0.9,0.3-1.7,0.9-2.3c0.6-0.6,1.4-1,2.3-1h9.3c0.5,0,0.9,0.1,1.3,0.3c0.1,0.1,0.2,0.1,0.2,0.3c0,0.1,0,0.2-0.1,0.3l-0.5,0.6 c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.3-0.1-0.5-0.1h-9.3c-0.5,0-0.9,0.2-1.3,0.5c-0.4,0.4-0.5,0.8-0.5,1.3v9.5 c0,0.5,0.2,0.9,0.5,1.3c0.4,0.4,0.8,0.5,1.3,0.5h9.3c0.5,0,0.9-0.2,1.3-0.5c0.4-0.4,0.5-0.8,0.5-1.3v-1.4c0-0.1,0-0.2,0.1-0.3 l0.7-0.7C1057.3,417.2,1057.4,417.2,1057.6,417.2z M1049.2,416.8l7.5-7.6l3.2,3.3l-7.5,7.6h-3.2V416.8z M1062,409.9 c0,0.3-0.1,0.6-0.3,0.8l-1,1l-3.2-3.3l1-1c0.2-0.2,0.5-0.3,0.8-0.3s0.6,0.1,0.8,0.3l1.7,1.7C1061.9,409.3,1062,409.6,1062,409.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.68afb5400365170da8db5273f88177c8.svg";
export { ForwardRef as ReactComponent };